export const homepageClients = [
  {
    name: 'Bait Al Sahil Trading LLC',
    logo: '/assets/images/oman-projects/bait-al-sahil-logo.png',
    logoVariant: 'logo-extra-wide',
    href: 'https://baitalsahil.com/',
    location: 'Oman',
    workType: 'Website',
  },
  {
    name: 'Maarij International LLC',
    logo: '/assets/images/clients/maarij-logo-transparent-blue.webp',
    logoVariant: 'logo-tall',
    href: 'https://maarijinternational.com/',
    location: 'Oman',
    workType: 'Website',
  },
  {
    name: 'Quick Seva',
    logo: '/assets/images/clients/Quick _Seva_logo.webp',
    logoVariant: 'logo-square',
    href: 'https://play.google.com/store/apps/details?id=com.quickseva.user2026',
    location: 'India',
    workType: 'Mobile App',
  },
  {
    name: 'Zarvo User',
    logo: '/assets/images/clients/zarvo-user-icon.webp',
    logoVariant: 'logo-app',
    href: 'https://play.google.com/store/apps/details?id=com.zarvo.user2026',
    location: 'India',
    workType: 'Mobile App',
  },
  {
    name: 'Velvet Scent',
    logo: '/assets/images/clients/Velvet Scent _Logo.webp',
    logoVariant: 'logo-tall',
    href: 'https://www.velvetscent.in/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'Samast Muslim Ghanchi Samaj Modasa',
    logo: '/assets/images/clients/samast Muslim Ghanchi samaj.webp',
    logoVariant: 'logo-round',
    href: 'https://www.modasasamastghanchi.org/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'NRG Tax And Tech Solutions',
    logo: '/assets/images/clients/nrg_tax_and_tech_logo.webp',
    logoVariant: 'logo-wide',
    href: 'https://www.nrgtaxandtechsolutions.com/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'Aveda The Family Spa',
    logo: '/assets/images/clients/aveda-family-spa-logo-transparent.webp',
    logoVariant: 'logo-tall',
    href: 'https://theavedaspa.in/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'AutomizeHub AI',
    logo: '/assets/images/clients/automizehub-logo.png',
    logoVariant: 'logo-extra-wide',
    href: 'https://automizehub.ai/',
    location: 'India',
    workType: 'Website',
    isOwned: true,
  },
  {
    name: 'QuickSeva for Vendors',
    logo: '/assets/images/clients/quickseva-vendor-icon.png',
    logoVariant: 'logo-app',
    href: 'https://play.google.com/store/apps/details?id=com.quickseva.vendorapp2026',
    location: 'India',
    workType: 'Mobile App',
  },
  {
    name: 'Sukooon',
    logo: '/assets/images/clients/Sukoon-logo-first-part.jpeg',
    logoVariant: 'logo-round-large',
    brandTheme: 'sukooon',
    href: 'https://mysukooon.com/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'ScrapperTool',
    logo: '/assets/images/clients/scrappertool-logo.svg',
    logoVariant: 'logo-extra-wide',
    href: 'https://www.scrappertool.com/',
    location: 'India',
    workType: 'Website',
    isOwned: true,
  },
  {
    name: 'Zarvo Listener',
    logo: '/assets/images/clients/zarvo-listener-icon.webp',
    logoVariant: 'logo-app',
    href: 'https://play.google.com/store/apps/details?id=com.zarvo.listener2026',
    location: 'India',
    workType: 'Mobile App',
  },
  {
    name: 'QuickSeva PDF',
    logo: '/assets/images/clients/quickseva-pdf-icon.webp',
    logoVariant: 'logo-app',
    href: 'https://play.google.com/store/apps/details?id=com.quickseva.pdf',
    location: 'India',
    workType: 'Mobile App',
  },
  {
    name: 'Ankur Chemist',
    logo: '/assets/images/clients/ankur-chemist-logo.png',
    logoVariant: 'logo-extra-wide',
    href: 'https://ankurchemist.in/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'Shreenath Hospital',
    logo: '/assets/images/clients/shreenath-hospital-logo.png',
    logoVariant: 'logo-extra-wide',
    href: 'https://www.shreenathhospital.com/',
    location: 'India',
    workType: 'Website',
  },
  {
    name: 'Islamic And Tech',
    logo: '/assets/images/clients/islamic-and-tech-logo.png',
    logoVariant: 'logo-extra-wide',
    href: 'https://islamicandtech.com/',
    location: 'India',
    workType: 'Website',
  },
];

export const industries = [
  { name: 'E-commerce & Retail', icon: 'fa-shopping-cart', text: 'Online stores, product discovery and customer-focused buying experiences.' },
  { name: 'Manufacturing', icon: 'fa-cogs', text: 'Corporate websites, product catalogues and operational business systems.' },
  { name: 'Professional Services', icon: 'fa-briefcase', text: 'Credible digital presence and lead-focused workflows for service businesses.' },
  { name: 'Community Organizations', icon: 'fa-users', text: 'Accessible platforms that connect members, information and community services.' },
  { name: 'Wellness & Lifestyle', icon: 'fa-leaf', text: 'Modern brand experiences for wellness, personal care and consumer businesses.' },
  { name: 'On-demand Marketplaces', icon: 'fa-map-marker', text: 'Mobile-first service discovery, booking and local marketplace applications.' },
  { name: 'Fintech & Payments', icon: 'fa-credit-card', text: 'Payment integrations and secure digital transaction experiences.' },
  { name: 'Business Software', icon: 'fa-cogs', text: 'CRM, ERP, automation and custom tools built around real workflows.' },
];
